module.exports = __webpack_public_path__ + "be27b8c646a18839353277efe1210ec3.ttf";


//////////////////
// WEBPACK FOOTER
// ../app/assets/fonts/FuturaLT-Light.ttf
// module id = 424
// module chunks = 0